/**
 * 一般廃棄物品目
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/general_items`

const getDefaultState = () => {
  return {
  }
}

const general_item = {
  namespaced: true,
  state: () => {},
  getters: {},
  actions: {
    /**
     * 一般廃棄物品目一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ commit }, { without_invisible, page, limit }) {
      const params = { without_invisible: without_invisible, page: page, limit: limit }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {
  },
}

export default general_item
